import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ActionMenu } from '@core/components/ui';

/**
 * BaseTableActions Component
 *
 * Action menu (3-dot dropdown) for knowledge base table rows.
 * Uses ActionMenu component for consistent styling.
 *
 * @param {Object} props
 * @param {Object} props.base - Knowledge base object
 * @param {Function} props.onEdit - Callback when edit button is clicked
 * @param {Function} props.onDelete - Callback when delete button is clicked
 */
export function BaseTableActions({ base, onEdit, onDelete }) {
  const { t } = useTranslation();

  const menuItems = [
    {
      label: t('knowledgeBases.actions.edit', 'Edit'),
      icon: 'lucide:pencil',
      onClick: () => onEdit(base),
      variant: 'default',
    },
    {
      label: t('knowledgeBases.actions.delete', 'Delete'),
      icon: 'lucide:trash-2',
      onClick: () => onDelete(base),
      variant: 'danger',
    },
  ];

  return <ActionMenu items={menuItems} />;
}

BaseTableActions.propTypes = {
  base: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
